"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
exports.ErrorCode = {
    InvalidObjectId: 1000,
    SignUpUserExist: 1001,
    SignUpRoleDoesNotExist: 1002,
    SignUpExternalIntFailed: 1003,
    SignInUserNotFound: 1101,
    SignInInvalidPassword: 1102,
    SignInUnauthorizedRole: 1103,
    ResetPasswordNoUserFound: 1201,
    ResetPasswordEmailMismatched: 1202,
    ChangePasswordPasswordNotMatch: 1211,
    ValidateResetPasswordInvalidHash: 1301,
    ValidateResetPasswordNoResetPasswordRequest: 1302,
    ValidateResetPasswordResetPasswordRequestExpired: 1303,
    NewPasswordErrorEmailNotFound: 1401,
    VerifyEmailInvalidId: 1501,
    VerifyEmailEmailNotFound: 1502,
    UnsubscribeEmailNotFound: 1503,
    PropertyNoUserId: 1601,
    PropertyNoPropertyListings: 1602,
    PropertyNotAValidObjectId: 1603,
    PropertyIndexIsNotANumber: 1604,
    PropertyPackagesEmpty: 1605,
    PropertyStatusPending: 1606,
    PropertyNoPackageCategory: 1607,
    PropertyNoCoBroke: 1608,
    PropertyNotYetApproved: 1609,
    PropertyIsNotSubmittedForApproval: 1610,
    PropertyStatusIsNotPendingSignature: 1611,
    PropertyNoStripeId: 1612,
    PropertyPackagesStatusIsNotActive: 1613,
    PropertyManagementTransactionsNoListings: 1614,
    AdminOwnerEmailExist: 1701,
    AdminOwnerNoPropertyListingFound: 1702,
    AdminPropertyNoPropertyListings: 1711,
    AdminPropertyInvalidStatus: 1712,
    AdminPropertyInvalidObjectId: 1713,
    AdminPropertyNotTenanted: 1714,
    AdminPropertyGroupNotFound: 1715,
    AdminPropertyGroupNoRoom: 1716,
    AdminPropertyGroupNoImage: 1717,
    AdminReportIdInvalidObjectId: 1721,
    AdminReportOwnerNotFound: 1722,
    AdminReportPropertyListingsNotFound: 1723,
    AdminReportInvalidPropertyType: 1724,
    AdminReportInvalidStatus: 1725,
    AdminReportOwnerPropertyUserIdNotFound: 1726,
    AdminReportInvalidSortEnum: 1727,
    AdminPackagesNoEventTemplate: 1731,
    AdminPackagesNoCategoryEnum: 1732,
    AdminPackagesPropertyIsNotActive: 1733,
    AdminPackagesGoogleDriveSyncInvalidPackageType: 1734,
    AdminPackagesGoogleDriveSyncParentFolderPathMissing: 1735,
    AdminPackagesGoogleDriveSyncChildFolderPathMissing: 1736,
    AdminPackagesGoogleDriveSyncEmptyGoogleDrivePath: 1737,
    AdminPackagesFailedToUpdate: 1738,
    AdminPaymentInvalidStatusEnum: 1741,
    AdminPaymentNoPaymentListings: 1742,
    AdminREACoBrokeNoCoBrokeId: 1750,
    AdminREACoBrokeCannotSetToPending: 1751,
    AdminSubOwnerUnauthorized: 1760,
    AdminSubOwnerEmailAlreadyExist: 1761,
    AdminSubOwnerIdNotExist: 1762,
    OwnerPaymentInvalidCategoryNumber: 3001,
    OwnerPaymentPriceNotSet: 3002,
    OwnerPaymentNoPaymentListings: 3003,
    OwnerPaymentInvalidEnum: 3004,
    OwnerPaymentMustBeManualBankTransferEnum: 3005,
    OwnerPaymentNoPackageSelected: 3006,
    OwnerPaymentAlreadyApproved: 3007,
    OwnerPaymentWalletInsufficient: 3008,
    OwnerPackagesPendingStatus: 3100,
    OwnerWalletNoWalletTransaction: 3101,
    OwnerOfferNoSortPriceWithThisNumber: 3201,
    OwnerOfferSessionInvalidEnum: 3202,
    OwnerSubscriptionIsClosed: 3301,
    OwnerDetailsNotComplete: 3401,
    OwnerNotFound: 3402,
    REAUserNoUserId: 4001,
    REAPropertyNoPropertyFound: 4101,
    REAPropertyNoCoBroke: 4102,
    REAPropertyCannotSetToPastDate: 4103,
    REAUserInfoNotSet: 4104,
    REAOfferNoOfferSessionId: 4201,
    REAOfferSessionStopped: 4202,
    REAOfferNotYetStarted: 4203,
    OfferIDNotFound: 5001,
    EmailInNoMailList: 9001,
    EmailVerificationUpdateIdNotFound: 9002,
    UploadImageNoCategoryEnum: 9003,
    UploadImageNoURL: 9004,
    UploadNoMatchingId: 9005,
    InvalidObjectID: 9006,
    StripeSubscriptionNoListings: 9007,
    InvalidEnum: 9008,
    AWSUploadFileError: 9009,
    GeneralThirdPartyAPIError: 9010,
    UnknownError: 9999,
};
exports.default = {
    ErrorCode: exports.ErrorCode,
};
